import { RootState } from '@/shared/store'

import { planningShiftTablesAdapter } from '../adapters/planningShiftTablesAdapter'

export const planningShiftTablesSelector = planningShiftTablesAdapter.getSelectors<RootState>(
  (state) => state.planningShiftTables,
)
